import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div>
      <section className="bg-gradient-to-br from-primary/10 via-emerald-50 to-green-50 py-32 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-100/50 to-emerald-50/50 opacity-50"></div>
        <div className="container relative z-10 text-center">
          <div className="max-w-4xl mx-auto">
            <span className="inline-flex items-center gap-3 bg-white/80 backdrop-blur-sm px-8 py-4 rounded-3xl text-lg font-bold text-primary shadow-xl">
              <i className="fas fa-mosque text-2xl"></i>
              About Our Islamic School
            </span>
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-black bg-gradient-to-r from-primary via-primary-600 to-emerald-600 bg-clip-text text-transparent mt-8 mb-12 leading-tight">
              Excellence in Faith and Knowledge
            </h1>
            <p className="text-2xl text-slate-700 max-w-3xl mx-auto leading-relaxed">
              Founded with a mission to nurture the next generation of Muslim leaders through the perfect blend of Islamic values and modern academic excellence.
            </p>
          </div>
        </div>
      </section>

      <section className="py-32 bg-white">
        <div className="container">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            <div>
              <h2 className="text-5xl font-bold text-slate-900 mb-8">Our Mission</h2>
              <p className="text-xl text-slate-600 mb-12 leading-relaxed">
                To provide a holistic education that combines the timeless wisdom of Islamic teachings with contemporary academic excellence, producing well-rounded individuals who excel in both worldly and spiritual pursuits.
              </p>
              <div className="space-y-8">
                <div className="flex items-start gap-6 p-8 bg-slate-50/50 rounded-3xl hover:bg-slate-100 transition-all group">
                  <div className="w-16 h-16 bg-gradient-to-br from-primary to-primary-600 text-white rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-all">
                    <i className="fas fa-quran text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-slate-900 mb-3">Quranic Foundation</h4>
                    <p className="text-lg text-slate-600">Daily Quran recitation, memorization, and understanding form the bedrock of our curriculum</p>
                  </div>
                </div>
                <div className="flex items-start gap-6 p-8 bg-slate-50/50 rounded-3xl hover:bg-slate-100 transition-all group">
                  <div className="w-16 h-16 bg-gradient-to-br from-primary to-primary-600 text-white rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-all">
                    <i className="fas fa-graduation-cap text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-slate-900 mb-3">Modern Excellence</h4>
                    <p className="text-lg text-slate-600">Cambridge-standard academics with STEM focus alongside Arabic and Islamic studies</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-4xl p-12 shadow-2xl">
                <div className="w-full h-96 bg-gradient-to-br from-slate-200 to-slate-300 rounded-3xl shadow-2xl flex items-center justify-center">
                  <i className="fas fa-school text-9xl text-slate-400"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-16 flex flex-wrap justify-center gap-4">
            <Link to="/academics" className="bg-gradient-to-r from-primary to-primary-600 text-white px-10 py-4 rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all inline-flex items-center gap-3">
              <i className="fas fa-book-open"></i> Explore Academics
            </Link>
            <Link to="/admission" className="border-2 border-primary text-primary hover:bg-primary hover:text-white px-10 py-4 rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all inline-flex items-center gap-3">
              <i className="fas fa-user-plus"></i> Apply Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

